import "./DocumentUploadModalFooter.scss";

type DocumentUploadModalFooterProps = {
  children?: React.ReactNode;
};

export const DocumentUploadModalFooter = ({
  children,
}: DocumentUploadModalFooterProps) => {
  return (
    <footer className="ui-upload-modal-footer bg-white shadow">
      {children}
    </footer>
  );
};
